import {
    IDischargeCurveFittingService,
    IDischargeChartPoint,
    IFitDischargeModel
} from './discharge.types';
import {zip} from '../utils/iter-functions';

export default class DischargeCurveFittingService implements IDischargeCurveFittingService {
  fitCurveQuadraticMethod(dischargePoints:Array<IDischargeChartPoint>):IFitDischargeModel {
    const fitSolution = DischargeCurveFittingService.leastSquaresFit(
        dischargePoints.map(dp => dp.waterLevel),
        dischargePoints.map(dp => Math.sqrt(dp.discharge)));

    return {
      paramA: fitSolution.a / fitSolution.b,
      paramB: 2,
      paramC: Math.pow(fitSolution.b, 2),
      paramDeltaLevel: 0
    };
  }

  private static leastSquaresFit(xValues:Array<number>, yValues:Array<number>):{a:number,b:number,r:number} {
    const meanX = mean(xValues);
    const meanY = mean(yValues);

    const ssxx = xValues.reduce((v, u) => v + Math.pow(u - meanX, 2), 0);
    const ssyy = yValues.reduce((v, u) => v + Math.pow(u - meanY, 2), 0);
    const ssxy = zip<number, number>(xValues, yValues).reduce(
        (v, [a, b]) => v + ((a - meanX) * (b - meanY)), 0);

    return {
      a: meanY - (ssxy * meanX / ssxx),
      b: ssxy / ssxx,
      r: Math.pow(ssxy, 2) / (ssxx * ssyy)
    };
  }
}

function mean(values:Array<number>) {
  return values.reduce((v, u) => v + u, 0) / values.length;
}



/** WEBPACK FOOTER **
 ** ./app/discharge/fitting.service.ts
 **/